export enum ContactFormDataHooks {
  ROOT = 'ContactForm',
  SUBMITTED_MESSAGE = 'ContactFormSubmittedMessage',
}
